import store from '@/store'

const firstTab = (store.getters.currentUserRole === 'brigadier' || store.getters.currentUserRole === 'production-master' || store.getters.currentUserRole === 'executor') ? { name: 'LaunchOrderList' } : { name: 'OrderListItem' }

export default firstTab
